import { CampaignCreate, CampaignListResponse, CampaignPreviewRequest, CampaignPreviewResponse, CampaignRecipientListResponse, CampaignScheduleRequest, CampaignSummarySchema, CampaignTransitionRequest, } from '@aeris/contracts';
import { request } from "./client.js";
export const fetchCampaigns = async (signal) => CampaignListResponse.parse(await request('/api/v1/communication/campaigns', { signal })).campaigns;
export const previewCampaignSegment = async (input) => CampaignPreviewResponse.parse(await request('/api/v1/communication/campaigns/preview', {
    method: 'POST',
    body: CampaignPreviewRequest.parse(input),
}));
export const createCampaign = async (input) => CampaignSummarySchema.parse(await request('/api/v1/communication/campaigns', {
    method: 'POST',
    body: CampaignCreate.parse(input),
}));
const campaignTransition = async (id, action, input) => CampaignSummarySchema.parse(await request(`/api/v1/communication/campaigns/${id}/${action}`, {
    method: 'POST',
    body: CampaignTransitionRequest.parse(input),
}));
export const scheduleCampaign = async (id, input) => CampaignSummarySchema.parse(await request(`/api/v1/communication/campaigns/${id}/schedule`, {
    method: 'POST',
    body: CampaignScheduleRequest.parse(input),
}));
export const startCampaign = async (id, input) => await campaignTransition(id, 'start', input);
export const pauseCampaign = async (id, input) => await campaignTransition(id, 'pause', input);
export const resumeCampaign = async (id, input) => await campaignTransition(id, 'resume', input);
export const cancelCampaign = async (id, input) => await campaignTransition(id, 'cancel', input);
export const fetchCampaignRecipients = async (id, signal) => CampaignRecipientListResponse.parse(await request(`/api/v1/communication/campaigns/${id}/recipients`, {
    signal,
})).recipients;
//# sourceMappingURL=communication-campaigns.js.map